import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { MatDividerModule } from '@angular/material/divider';
import { MatLegacyMenuModule } from '@angular/material/legacy-menu';
import { IconComponent, trackByFactory } from '@mode/capra';

export interface MenuItem {
  readonly value: { isContinuous: boolean; isDiscrete: boolean };
  readonly name: string;
  readonly icon?: string;
}

@Component({
  standalone: true,
  imports: [CommonModule, IconComponent, MatDividerModule, MatLegacyMenuModule],
  selector: 'mode-labeled-field-list-menu',
  templateUrl: './labeled-field-list-menu.component.html',
  styleUrls: ['./labeled-field-list-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LabeledFieldListMenuComponent {
  @Input() label = '';
  @Input() selected: MenuItem | undefined;
  @Input() fieldsInEncoding: MenuItem[] = [];
  @Input() otherFields: MenuItem[] = [];
  @Input() disabled = false;

  @Output() menuChange = new EventEmitter<MenuItem>();

  trackByName = trackByFactory<MenuItem>(({ name }) => name);
  isOpen = false;

  onChange(opt: MenuItem) {
    this.menuChange.emit(opt);
  }
}
